export const managerPrices = {
  page: {
    title: "Ceny platformy",
    subtitle: "Lista cen planów platformy",
  },
  table: {
    name: "Nazwa",
    type: "Typ",
    price: "Cena",
    created: "Utworzono",
    edit: "Edytuj cenę",
  },
  form: {
    title: "Aktualizuj cenę",
    planName: "Nazwa planu",
    planType: "Typ planu",
    annual: "Roczny",
    monthly: "Miesięczny",
    cancel: "Anuluj",
    save: "Zapisz",
  },
  toast: {
    saved: "Zapisano pomyślnie",
    error: "Błąd żądania",
  },
};
